import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading,
		user,
		isAuth,
		impersonation,
		handleLogin,
		handleLogout,
		handleImpersonate,
		handleStopImpersonation,
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading,
				user,
				isAuth,
				impersonation,
				handleLogin,
				handleLogout,
				handleImpersonate,
				handleStopImpersonation,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };

